<section>
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <span class="subtitle bg-primary-opacity">{{'Contact Us' | translate}}</span>
                        <h2 class="title">{{'contactways' | translate}}</h2>
                    </div>
                </div>
            </div>
            <div class="row g-5">
                <div class="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="150" data-sal-duration="800">
                    <div class="rbt-address">
                        <div class="icon">
                            <i class="feather-headphones"></i>
                        </div>
                        <div class="inner">
                            <h4 class="title">{{'throPhone' | translate}}</h4>
                            <p><a href="tel:+966555979380">+966 555 979 380</a></p>
                            <p><a href="tel:+966555979380">+966 114 501 055</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="200" data-sal-duration="800">
                    <div class="rbt-address">
                        <div class="icon">
                            <i class="feather-mail"></i>
                        </div>
                        <div class="inner">
                            <h4 class="title">{{'throEmail' | translate}}</h4>
                            <p><a href="mailto:Admin@learnyhome.com">Admin@learnyhome.com</a></p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 col-12 sal-animate" data-sal="slide-up" data-sal-delay="250" data-sal-duration="800">
                    <div class="rbt-address">
                        <div class="icon">
                            <i class="feather-map-pin"></i>
                        </div>
                        <div class="inner">
                            <h4 class="title">{{'site' | translate}}</h4>
                            <p>{{'thesite' | translate}}</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-contact-address">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-6">
                    <div class="thumbnail">
                        <img class="w-100 radius-6" src="../../../assets/images/contact.png" alt="Contact Images">
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="rbt-contact-form contact-form-style-1 max-width-auto">
                        <div class="section-title text-start">
                            <span class="subtitle bg-primary-opacity">{{'sendToUs' | translate}}</span>
                        </div>
                        <h3 class="title">{{'youcanwrite' | translate}}</h3>
                        <form #CourseForm="ngForm" id="CourseForm" novalidateclass="rainbow-dynamic-form max-width-auto">
                            <div class="form-group">
                                <input name="name" id="name" type="text" [(ngModel)]="contactMsg.name" required ngModel #name="ngModel" placeholder="{{'contactName' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                <span class="focus-border"></span>
                            </div>
                            <div class="form-group">
                                <input name="email" id="email" type="text" required [(ngModel)]="contactMsg.email" ngModel required #email="ngModel" placeholder="{{'Email' | translate}}" [email]="true">
                                <span class="focus-border"></span>
                            </div>
                            <div class="form-group">
                                <input name="subject" id="subject" type="text" required [(ngModel)]="contactMsg.subject" ngModel #subject="ngModel" placeholder="{{'contactSubject' | translate}}" [maxlength]="150" pattern="[أ-يa-zA-z ]*">
                                <span class="focus-border"></span>
                            </div>
                            <div class="form-group">
                                <textarea name="msg" id="msg" [(ngModel)]="contactMsg.msg" required ngModel #msg="ngModel" ></textarea>
                                <label>{{'msg' | translate}}</label>
                                <span class="focus-border"></span>
                            </div>
                            <div class="form-submit-group">
                                <button name="submit" type="submit" id="submit" class="rbt-btn btn-gradient hover-transform-none w-100"  [class.spinner]="loading" (click)="sendMsg()" [disabled]="!(CourseForm.valid && CourseForm.dirty && !loading) || loading">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text">{{'send' | translate}}</span>
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="rbt-google-map bg-color-white rbt-section-gapTop">
        <iframe class="w-100" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14493.769657537634!2d46.7084005!3d24.7460159!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03ee7e45fedd%3A0x8490f6c733bae4dc!2z2LTYsdmD2Kkg2YbYuNmFINin2YTYr9mI2KfZhCDZhNiq2YLZhtmK2Kkg2KfZhNmF2LnZhNmI2YXYp9iq!5e0!3m2!1sar!2seg!4v1705311233820!5m2!1sar!2seg" height="600" style="border:0"></iframe>
    </div>
</section>
